import React from 'react'
import EChartComponent from '@/components/EChartComponent'
import { Col, Row, Segmented, Table, DatePicker } from 'antd'
interface styleInterface {
  style?: any
  name?: string
}
const ComponentName: React.FC<styleInterface> = React.memo((props) => {
  const option: echarts.EChartsOption = {
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: [
        'PV-Real-time Power',
        'Battery-SOC',
        'Load-Real-time Power',
        'Grid-Real-time Power',
        'Gen-Real-time Power',
      ],
      type: 'scroll',
      pageIconColor: '#000',
      pageIconInactiveColor: '#999',
      pageIconSize: 10,
      pageTextStyle: {
        fontSize: 12,
        color: '#000',
      },
      bottom: 0,
      left: 'center',
      textStyle: {
        fontSize: 12,
        color: '#000',
      },
      inactiveColor: '#999999', // This sets the color for inactive legend items
    },
    grid: {
      top: 50,
      left: 40,
      bottom: 60,
      right: 60,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        fontSize: 12,
        formatter: (value: string) => value, // Format to show time directly
      },
      data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00'],
    },
    yAxis: [
      {
        type: 'value',
        name: 'Power (kW)',
        position: 'left',
        nameTextStyle: {
          padding: [0, 0, 20, 0],
        },
        axisLabel: {
          fontSize: 12,
        },
        splitLine: {
          show: true,
        },
      },
      {
        type: 'value',
        name: 'SOC (%)',
        position: 'right',
        nameTextStyle: {
          padding: [0, 0, 20, 0],
        },
        axisLabel: {
          fontSize: 12,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: 'PV-Real-time Power',
        type: 'line',
        yAxisIndex: 0,
        data: [5, 10, 15, 20, 25, 30, 35, 40],
        lineStyle: {
          width: 2,
          color: '#405DF9',
        },
        smooth: true, // Enable smooth curve
        symbol: 'none',
      },
      {
        name: 'Battery-SOC',
        type: 'line',
        yAxisIndex: 1,
        data: [50, 55, 60, 65, 70, 75, 80, 85],
        lineStyle: {
          width: 2,
          color: '#FF6F61',
        },
        smooth: true, // Enable smooth curve
        symbol: 'none',
      },
      {
        name: 'Load-Real-time Power',
        type: 'line',
        yAxisIndex: 0,
        data: [10, 15, 20, 25, 30, 35, 40, 45],
        lineStyle: {
          width: 2,
          color: '#4CAF50',
        },
        smooth: true, // Enable smooth curve
        symbol: 'none',
      },
      {
        name: 'Grid-Real-time Power',
        type: 'line',
        yAxisIndex: 0,
        data: [7, 14, 21, 28, 35, 42, 49, 56],
        lineStyle: {
          width: 2,
          color: '#FF9800',
        },
        smooth: true, // Enable smooth curve
        symbol: 'none',
      },
      {
        name: 'Gen-Real-time Power',
        type: 'line',
        yAxisIndex: 0,
        data: [8, 16, 24, 32, 40, 48, 56, 64],
        lineStyle: {
          width: 2,
          color: '#9C27B0',
        },
        smooth: true, // Enable smooth curve
        symbol: 'none',
      },
    ],
  }
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <Row style={{ height: '5%' }}>
        <Col span={8}>
          <span className='Solar-three-title'>{props.name || 'Chart Name'}</span>
        </Col>
        <Col span={16}>
          <div className='filter'>
            <Segmented defaultValue='D' style={{ marginBottom: 8 }} options={['D', 'W', 'M', 'Y']} />
            <DatePicker
              suffixIcon=<img src='/assets/image/date.svg' />
              format={{
                format: 'DD-MM-YYYY',
                type: 'mask',
              }}
            />
            <Segmented defaultValue='5Min' style={{ marginBottom: 8 }} options={['5Min', '15Min', '30Min', '60Min']} />
          </div>
        </Col>
      </Row>
      <div style={{ height: '95%', padding: '10px' }}>
        <EChartComponent staticOption={option} />
      </div>
    </div>
  )
})

export default ComponentName
